import React, { useEffect, useState } from "react";
import styles from "features/BaseReportLayoutLeft/styles.module.scss";
import { useAtom } from "jotai/index";
import { transformItemsGroup } from "features/ProductsGroup/helpers";
import classNames from "classnames";

import { Accordion } from "components/Accordion/Accordion";
import { Checkbox } from "components/Checkbox/Checkbox";
import { RegularText } from "components/RegularText/RegularText";
import { Button } from "components/Button/Button";

import { ItemsGroupWithChildren } from "../../types";
import { allItemsGroupsAtom } from "../../atoms/itemAtom";
import { reportsFiltersAtom } from "../../atoms/reportsAtom";

export const Body = (): JSX.Element => {
  const [reportsFilters, setReportsFilters] = useAtom(reportsFiltersAtom);
  const [itemsGroup] = useAtom(allItemsGroupsAtom);
  const transformedItemGroups: ItemsGroupWithChildren[] = transformItemsGroup([
    ...itemsGroup,
  ]);
  const [expandedAccordions, setExpandedAccordions] = useState<Set<string>>(
    new Set()
  );

  const toggleAccordion = (itemgroupid: string) => {
    setExpandedAccordions((prevState) => {
      const newExpanded = new Set(prevState);
      if (newExpanded.has(itemgroupid)) {
        newExpanded.delete(itemgroupid);
      } else {
        newExpanded.add(itemgroupid);
      }
      return newExpanded;
    });
  };

  const findGroupsAllChildrenRecursive = (groupIds: string[] = []) => {
    const firstChildrenIds = itemsGroup
      .filter((i) => groupIds.includes(i.parentid))
      .map((i) => i.itemgroupid);

    if (!firstChildrenIds.length) {
      return [];
    }

    return [
      ...firstChildrenIds,
      ...findGroupsAllChildrenRecursive(firstChildrenIds),
    ];
  };

  const handleSelect = (groupId: string) => {
    let newSelectedValues = [...reportsFilters.itemGroupIds];
    if (newSelectedValues.includes(groupId)) {
      newSelectedValues = newSelectedValues.filter((i) => i !== groupId);
    } else {
      const allChildrenIds = findGroupsAllChildrenRecursive([groupId]);
      newSelectedValues.push(groupId, ...allChildrenIds);
      newSelectedValues = [...new Set(newSelectedValues)];
    }
    setReportsFilters({ itemGroupIds: newSelectedValues } as any);
  };

  const selectAll = () => {
    setReportsFilters({
      itemGroupIds: itemsGroup.map((i) => i.itemgroupid),
    } as any);
  };

  const removeAll = () => {
    setReportsFilters({
      itemGroupIds: [],
    } as any);
  };

  const renderItemsGroups = (items: ItemsGroupWithChildren[]) =>
    items.map((item) => {
      const { children } = item;

      if (children && children.length > 0) {
        return (
          <Accordion
            key={item.itemgroupid}
            withIcon
            className={styles.checkBoxRow}
            childrenClassName={styles.checkBoxRow}
            collapsed={!expandedAccordions.has(item.itemgroupid || "")}
            parent={
              <div
                onClick={() => {
                  toggleAccordion(item.itemgroupid || "");
                }}
                className={classNames(styles.checkBox, styles.checkBoxToOpen)}
                key={item.itemgroupid}
              >
                <div
                  onClick={(ev) => {
                    ev.stopPropagation();
                    handleSelect(item.itemgroupid);
                  }}
                >
                  <Checkbox
                    onClick={(ev) => {
                      ev.preventDefault();
                    }}
                    checked={reportsFilters.itemGroupIds.includes(
                      item.itemgroupid
                    )}
                  />
                </div>
                <RegularText>{item.name}</RegularText>
              </div>
            }
          >
            <div className="pl-5">{renderItemsGroups(children)}</div>
          </Accordion>
        );
      }

      return (
        <div className={styles.checkBox} key={item.itemgroupid}>
          <div
            onClick={(ev) => {
              ev.stopPropagation();
              handleSelect(item.itemgroupid);
            }}
          >
            <Checkbox
              onClick={(ev) => {
                ev.preventDefault();
              }}
              checked={reportsFilters.itemGroupIds.includes(item.itemgroupid)}
            />
          </div>
          <RegularText>{item.name}</RegularText>
        </div>
      );
    });

  return (
    <div>
      <div className={styles.buttonsRow}>
        <Button
          onClick={selectAll}
          disabled={reportsFilters.itemGroupIds.length === itemsGroup.length}
        >
          Выбрать все
        </Button>
        <Button
          onClick={removeAll}
          disabled={reportsFilters.itemGroupIds.length === 0}
        >
          Снять все
        </Button>
      </div>
      {renderItemsGroups(transformedItemGroups)}
    </div>
  );
};
